import type React from 'react';

type Mutable<T> = {
  -readonly [k in keyof T]: T[k];
};

export const mergeRefs =
  <T>(...refs: (React.Ref<T> | undefined)[]) =>
  (value: T): void => {
    for (const ref of refs) {
      if (!ref) continue;

      if (typeof ref === 'function') {
        ref(value);
      } else {
        (ref as Mutable<React.RefObject<T>>).current = value;
      }
    }
  };
